import React from 'react'
import { Box, Tooltip, Typography } from '@mui/material'
import { IoCheckmarkCircle } from 'react-icons/io5'
import { PiSealPercentFill } from 'react-icons/pi'
import WhatshotIcon from '@mui/icons-material/Whatshot'
import { LuCircle } from 'react-icons/lu'
import RouterHook from '../../../contexts/RouterHook'
import moment from 'moment'
import { ToastMessages } from '../../ToastMessages'
import { stDesk } from './styles'
import { EmpresasContext } from '../../../contexts/EmpresasContext'
import { AgendamentoContext } from '../../../contexts/AgendamentoContext'

export default function ButtonHorario({ horario, disabled, onChange, isSelected, isNobre = false, reagendavel = false }) {
  const serverRouter = RouterHook()
  const { sttPg } = React.useContext(EmpresasContext)
  const { sttCtxAgend } = React.useContext(AgendamentoContext)

  const handleChange = () => {
    const newIsChecked = !isSelected
    onChange(newIsChecked)
  }

  const avoidDetalhesAgendamentoWhenRescheduling = () => {
    ToastMessages.cannotOpenDetailsWhileRescheduling()
  }

  const lottieRef = React.useRef(null)
  React.useEffect(() => {
    const interval = setInterval(() => {
      if (lottieRef.current) {
        lottieRef.current.setSpeed(4)
        clearInterval(interval)
      }
    }, 100)

    return () => clearInterval(interval)
  }, [isSelected])

  const solicitei = (horario.status === 'AGENDADO' || horario.status === 'SOLICITADO') && disabled === 'agendei'

  function DetalhesPedido() {
    if (Object.keys(sttCtxAgend.reagendamento).length === 0) {
      serverRouter('agendamento', horario.idpedido)
    } else {
      avoidDetalhesAgendamentoWhenRescheduling()
    }
  }

  function ReturnValue() {
    if (horario.promocao) {
      return (
        <>
          <Typography sx={{ textDecoration: 'line-through', color: 'grey', marginRight: '2px' }} variant='body2' fontSize='13px'>
            {horario.valor.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            })}
          </Typography>
          <Typography sx={{ color: 'success.green', marginLeft: '2px' }} variant='body1' fontWeight='bold' fontSize='13px'>
            {horario.valorPromocional.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            })}
          </Typography>
        </>
      )
    } else {
      return (
        <Typography variant='body2' sx={{ fontSize: '14px', fontWeight: 'bold', textAlign: 'center' }}>
          {horario.valor.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
          })}
        </Typography>
      )
    }
  }

  function ReturnStatus() {
    if (!solicitei)
      return (
        <Typography variant='body2' color='text.secondary' fontWeight='bold' fontSize='11px'>
          OCUPADO
        </Typography>
      )
    else if (solicitei) {
      if (reagendavel)
        return (
          <Typography variant='body2' color={'warning.main'} fontWeight={'bold'}>
            REAGENDAR
          </Typography>
        )
      else
        return (
          <Typography variant='body2' color={horario.status === 'SOLICITADO' ? 'primary.main' : 'success.main'} fontWeight={'bold'}>
            {horario.status}
          </Typography>
        )
    }
  }

  return (
    <Tooltip
      title={
        solicitei && sttPg.selectedHorarios.length === 0 ? (!reagendavel ? 'Observar detalhes do seu agendamento' : 'Horário a ser reagendado') : ''
      }
    >
      <button
        style={{
          ...stDesk.containButton,
          backgroundColor: `${
            solicitei ? (!reagendavel ? (horario.status === 'SOLICITADO' ? '#fcd0c2' : '#bce3c4') : 'rgba(255, 174, 25, 0.3)') : 'background.paper'
          }`,
          opacity: `${disabled === 'invalido' || (solicitei && sttPg.selectedHorarios.length > 0) || reagendavel ? 0.5 : 1}`,
          cursor: `${disabled === 'invalido' || (solicitei && sttPg.selectedHorarios.length > 0) || reagendavel ? 'default' : 'pointer'}`,
        }}
        onClick={!solicitei ? handleChange : DetalhesPedido}
        disabled={disabled === 'invalido' || (solicitei && sttPg.selectedHorarios.length > 0) || reagendavel}
      >
        <Box sx={stDesk.containSelectedBtt} marginRight={'7px'}>
          {!solicitei && horario.status !== 'SOLICITADO' && horario.status !== 'AGENDADO' && (
            <Tooltip title='Selecionar horário'>
              <span>
                {isSelected ? <IoCheckmarkCircle style={{ ...stDesk.iconBtt, color: '#12C06A' }} /> : <LuCircle size={18} color={'gray'} />}
              </span>
            </Tooltip>
          )}
        </Box>
        <Box sx={stDesk.containCentral}>
          <Typography variant='body2' sx={stDesk.labelBtt}>
            {`${moment(horario.dataInicio).format('HH:mm') + ' às ' + moment(horario.dataFinal).format('HH:mm')}`}
          </Typography>
          <Box sx={stDesk.containCentralInferior}>{horario.status === 'livre' ? ReturnValue() : ReturnStatus()}</Box>
        </Box>
        <Box sx={stDesk.containIcons}>
          {horario.status === 'livre' &&
            (isNobre && horario.promocao ? (
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, justifyContent: 'center', alignItems: 'center' }}>
                <Tooltip title='Nobre' placement='right'>
                  <span>
                    <Box sx={stDesk.containNobre}>
                      <WhatshotIcon color='gold' fontSize='small' sx={{ height: '17px', width: '17px' }} />
                    </Box>
                  </span>
                </Tooltip>
                <Tooltip title='Promoção' placement='right'>
                  <span>
                    <Box sx={stDesk.containPromocao}>
                      <PiSealPercentFill color='success.green' fontSize='large' sx={{ height: '17px', width: '17px' }} />
                    </Box>
                  </span>
                </Tooltip>
              </Box>
            ) : isNobre ? (
              <Tooltip title='Nobre' placement='right'>
                <span>
                  <Box sx={stDesk.containNobre}>
                    <WhatshotIcon color='gold' fontSize='small' sx={{ height: '17px', width: '17px' }} />
                  </Box>
                </span>
              </Tooltip>
            ) : (
              horario.promocao && (
                <Tooltip title='Promoção' placement='right'>
                  <span>
                    <Box sx={stDesk.containPromocao}>
                      <PiSealPercentFill color='success.green' fontSize='large' sx={{ height: '17px', width: '17px' }} />
                    </Box>
                  </span>
                </Tooltip>
              )
            ))}
        </Box>
      </button>
    </Tooltip>
  )
}
